const byItemTypeFilter = function (items, itemType) {
    return items.filter((item) => item.itemType && item.itemType.indexOf(itemType) !== -1);
};

module.exports = byItemTypeFilter;
